import React, { Component } from "react";
import styled from "styled-components";
import gridData from "../json/bottomgrid.json";
import { handleSendSms } from "../scripts/helper";
import { HistorySelector, SelectedDeviceSelector } from "../redux/selector";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { SetHistory } from "../redux/actions";
import moment from "moment-jalali";

const Container = styled.div`
  width: 100%;
  padding: 0 20px 15px;
  min-height: 25vh;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-gap: 15px;
`;
const Item = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
`;
const Logo = styled.img`
  width: 60px;
  transition: 100ms;
  &:active {
    transform: scale(0.85);
  }
`;
const Name = styled.strong``;

class BottomGridComponent extends Component {
  handleClickItem = (item) => {
    const { selectedDevice, history, setHistory } = this.props;
    const sound = new Audio("/assets/smsSended.mp3");
    if (item.id === 3) {
      //
      if (!!history.length) {
        if (history.length > 10) {
          history.shift();
        }
        setHistory([
          ...history,
          {
            text: "شنود",
            device: selectedDevice,
            date: moment().locale("fa").format("jYYYY/jM/jD HH:mm"),
          },
        ]);
      } else {
        setHistory([
          {
            text: "شنود",
            device: selectedDevice,
            date: moment().locale("fa").format("jYYYY/jM/jD HH:mm"),
          },
        ]);
      }

      var a = document.createElement("a");
      a.setAttribute("href", `tel:+98${selectedDevice}`);
      sound.play();
      a.click();
    } else {
      handleSendSms(item.name, selectedDevice);
    }
  };
  render() {
    return (
      <Container>
        {gridData.map((item) => (
          <Item key={item.id} onClick={() => this.handleClickItem(item)}>
            <Logo src={`/assets/${item.image}`} alt="Xitonix action" />
            <Name>{item.name}</Name>
          </Item>
        ))}
      </Container>
    );
  }
}

const mapStateToProps = createStructuredSelector({
  selectedDevice: SelectedDeviceSelector,
  history: HistorySelector,
});
const mapDispatchToProps = (dispatch) => ({
  setHistory: (data) => dispatch(SetHistory(data)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BottomGridComponent);
